import React, {ReactElement, useEffect, useState} from 'react';
import {
  Button,
  Card,
  CardContent,
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Tooltip,
  Link
} from '@material-ui/core';
import {Trans, useTranslation} from 'react-i18next';
import {connect, useDispatch, useSelector} from 'react-redux';
import {isMobile} from 'react-device-detect';

// Components and navigation routes, styles variables,
import BackNavigation from '../backNavigation/BackNavigation';
import NavRoutes from 'src/constants/route/NavRoutes';
import {APP, GET_8_PIXEL_BOX} from 'src/style/variable';
import ClinicGroupsIcon from '@components/system/MyIcons/ClinicGroupsIcon';

import PaymentsCard from '../paymentsCard/PaymentsCard';
import PaymentsDetails from '../paymentdetails/PaymentsDetails';
import Loader from '@components/framework/loader/Loader';

// redux state action method
import {
  _guarantorPayAmount,
  _guarantorPayCashAmount,
  _patientPaymentDetailsId,
  _setPatientPaymentsToken,
  _guarantorLogin,
  _saveClinicDetails,
  _updateShowDueNoticeFirstTime,
  // _updatePaymentType,
  _saveAmountsAndRequiredDataForPayment,
  _saveBalanceForwardData,
  _setPatientTicketAndAppointmentSummary
} from '@shared/store/actions/PaymentActions';
import {_guarantorLogout} from '@shared/store/actions/LogoutActions';
// styles
import './PaymentsDashboardStyles.scss';
import {
  fetchGuarantorPatients,
  fetchPatientTicketAndAppointmentSummary,
  guarantorRefresh,
  verifyGuarantorToken
} from '@shared/services/Payment.service';
import {
  LocationsInterface,
  VerifyGuarantorTokenPaymentServiceMapper
} from '@shared/services/service-mappers/PaymentServiceMapper';
import GuarantorPaymentDetails from '../paymentdetails/GuarantorPaymentDeatils';
import {StatementNoticeType} from '@shared/constants/Mapping';
import GuarantorNotice from './GuarantorNotice';
import HelperUtils from '@shared/utils/HelperUtils';
import {APP_PRIMARY_COLOR, BORDER_COLOR} from 'src/style/variable';
import {BASE_DETAILS, LOCATIONS} from '@shared/store/actions/Index';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CurrencyFormatter from '@components/system/CurrencyFormatter/CurrencyFormatter';
import PhoneFormatter from '@components/system/PhoneFormatter/PhoneFormatter';
import PracticeSelection from './components/PracticeSelection';
import InitSharedRepo from '../../../../../shared';
import {logoutGuarantor} from '@shared/services/CommonServices';
import {State} from '@shared/store/reducers/Index';
import PublicPageLayout from '../PublicPageLayout/PublicPageLayout';
import MedopsLogo from '@components/system/MyIcons/MedopsLogo';
import {environment} from '@shared/environment/environment';
// import {_appointmentPortalLogin} from '@shared/store/actions/AppointmentSchedularAction';
// import {State} from '@shared/store/reducers/Index';

const {innerWidth: width} = window;
const isDesktop = width >= 1024;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginButton: {
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem'
    },
    card: {
      borderRadius: 0,
      boxShadow: 'none'
    },
    cardPadding: {
      '& .MuiCardContent-root': {
        padding: 0
      },
      padding: 0
    },
    scrollSection: {
      // overflow: 'auto',
      height: '100%',
      padding: '0 12px 32px 0'
    },
    noticeTypeWrapper: {
      fontSize: '1.125rem',
      color: APP.COLOR.NOTICE_TYPE.FN,
      padding: '8px 0',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    noBalanceText: {
      margin: '12px 0',
      textAlign: 'left'
    },
    viewNoticeButton: {
      borderColor: APP.COLOR.NOTICE_TYPE.FN,
      color: APP.COLOR.NOTICE_TYPE.FN
    },
    link: {
      cursor: 'pointer',
      color: APP_PRIMARY_COLOR,
      textDecoration: 'underline',
      fontSize: '1rem',
      lineHeight: '1rem'
    },
    displayFlex: {
      display: 'flex'
    },
    linkPadding: {
      paddingLeft: '1rem'
    },
    paddingZero: {
      padding: 0
    },
    clickHereLink: {
      fontWeight: 'bold',
      fontSize: '1rem'
    }
  })
);
// TODO: Declare an interface and Give proper types to the below interface
const PaymentsDashBoard = (props: any): ReactElement => {
  const classes = useStyles();
  const {history, match, isLogin} = props;
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [
    apiResponseData,
    setApiResponseData
  ] = useState<VerifyGuarantorTokenPaymentServiceMapper>();
  // const appointmentPortalLogin = useSelector(
  //   (state: State) => state.appointmentPortal.isLogin
  // );
  const [gpPaymentDetailsFlag, setGpPaymentDetailsFlag] = useState<boolean>(
    false
  );

  const [paidAmount, setPaidAmount] = useState<number>(0);
  // const [isSettled, setPaymentSettled] = useState<boolean>(false);
  const payAmount = useSelector((state: any) => state.payments.payAmount);
  const [balanceHighlight, setBalanceHighlight] = useState({
    originalDueAmount: 0,
    paidDueAmount: 0
  });
  const [showAlertDialog, setAlertDialog] = useState<boolean>(false);
  const [buttonAlert, setButtonAlert] = useState<boolean>(true);
  const [viewButtonAlert, setViewButtonAlert] = useState<boolean>(false);
  const [disablePayButton, setDisablePayButton] = useState<boolean>(true);
  const [loader, setLoader] = useState<boolean>(true);
  const showDueNoticeFirstTime = useSelector(
    (state: any) => state.payments.showDueNoticeFirstTime
  );
  const [balanceForward, setBalanceForward] = useState<number>(0);

  const [changeLocation, setChangeLocation] = useState<boolean>(false);

  const locations: Array<LocationsInterface> = useSelector(
    (state: any) => state.payments.locations || []
  );
  const statementsEnable: boolean = useSelector(
    (state: any) =>
      state.payments.clinicDetails?.clinic_group_details?.statements || false
  );
  const paymentsEnable: boolean = useSelector(
    (state: any) =>
      state.payments.clinicDetails?.clinic_group_details?.payments || false
  );

  const [forceUpdate, setForceUpdate] = useState<number>(0);

  const [paymentPlanStatus, setPaymentPlanStatus] = useState<boolean>(false);
  const token = match.params.token;
  const backNavigation = (): void => {
    history.push(`/${NavRoutes.PUBLIC.PAYMENTS_LOGIN}/pay/${token}`);
  };

  const navigateToPaymentSection = (): void => {
    dispatch(_patientPaymentDetailsId({}));
    dispatch(_saveBalanceForwardData(null));
    history.push(`/${NavRoutes.PUBLIC.PAYMENTS_SECTION}/${token}`);
  };

  const logoutAction = async (): Promise<void> => {
    // making async call to logoff guarantor.
    logoutGuarantor();
    props._guarantorLogin(false);
    dispatch(_guarantorLogout());
    props._updateShowDueNoticeFirstTime(true);
    history.push(`/${NavRoutes.PUBLIC.PAYMENTS_LOGIN}/pay/${token}`);
  };

  const viewAllPaymentsOfGp = (): void => {
    setButtonAlert(false);
    setViewButtonAlert(true);
    props._patientPaymentDetailsId(null);

    // force update the component when view payments is called.
    setForceUpdate(prevForceUpdate => prevForceUpdate + 1);
    if (isDesktop) {
      setGpPaymentDetailsFlag(true);
    } else {
      history.push(`/${NavRoutes.PUBLIC.GUARANTOR_PAYMENT_DETAILS}/${token}`);
    }
  };

  const [sectionId, setSectionId] = useState<string | null>(null);

  const navigateToPaymentDetails = (
    patient: any,
    itemSectionId?: string
  ): void => {
    setButtonAlert(true);
    setViewButtonAlert(false);
    props._patientPaymentDetailsId(patient);
    setGpPaymentDetailsFlag(false);
    setSectionId(itemSectionId ?? null);
    if (!isDesktop) {
      history.push(
        `/${NavRoutes.PUBLIC.PAYMENTS_DETAILS}/${token}/${
          itemSectionId ? `${itemSectionId}` : 'details'
        }`
      );
    }
  };

  const handleSelectPractice = async (clinic: any): Promise<void> => {
    guarantorRefresh(clinic?.id)
      .then(res => {
        if (res.data) {
          InitSharedRepo.initAfterAuth({token: res.data?.token});
          props._setPatientPaymentsToken(res.data.token);
          // VERIFY REFRESH TOKEN...
          init(); // eslint-disable-line no-use-before-define
          // redirectToPaymentDashboard(res?.data?.token);
        }
      })
      .catch(err => {
        if (err) {
          logoutAction();
        }
      });
  };

  const [patientCardItems, setPatientCardItems] = useState<any[]>([]);

  const updatePatientsCardData = ({
    clinicDetails,
    patientsStatementsData,
    patientsList,
    clinicsList
  }: {
    patientsStatementsData: any[];
    clinicDetails: any;
    patientsList: any[];
    clinicsList: LocationsInterface[];
  }) => {
    const isConsolidatedBillingEnabled =
      clinicDetails?.clinic_group_details?.patients_shared &&
      clinicDetails?.clinic_group_details?.consolidated_group_billing;

    const patientItems: any[] = [];
    let clinicPatientStatementData: any[] = [];
    // IF CONSOLIDATED GROUP BILLING IS ENABLED, NO NEED TO FILTER
    if (isConsolidatedBillingEnabled) {
      clinicPatientStatementData = patientsStatementsData;
    } else {
      clinicPatientStatementData = patientsStatementsData.filter(
        patientStatement =>
          patientStatement?.clinic?.id === clinicDetails?.clinic_id
      );
    }
    patientsList.map(patient => {
      const curPatientStatements = clinicPatientStatementData.filter(
        patientStatement => patientStatement.emr_id === patient.emr_id
      );

      const clinicsWithCurrentPatientStatements: number[] = []; // Store the clinic ids in which patient is having statements
      curPatientStatements.map(statementItem => {
        let amount = 0;
        if (
          Array.isArray(statementItem.invoice) &&
          statementItem.invoice.length > 0
        ) {
          statementItem.invoice.forEach((invoice: any) => {
            amount += parseFloat(invoice.due_amount || '0');
          });
        }
        patientItems.push({
          ...patient,
          ...statementItem,
          total_statement_balance: amount
        });
        if (statementItem?.clinic?.id) {
          clinicsWithCurrentPatientStatements.push(statementItem?.clinic?.id);
        }
      });

      // SHOW THE PATIENT CARD, EVEN IF THE PATIENT DOESN'T HAVE ANY BALANCE
      if (isConsolidatedBillingEnabled) {
        // If consolidated billing is enabled, display a card for each clinic/location for the patient event if they don't have balance in that location
        clinicsList.map(clinic => {
          if (!clinicsWithCurrentPatientStatements.includes(clinic.id)) {
            patientItems.push({
              ...patient,
              clinic: {
                name: clinic.name,
                id: clinic.id
              },
              total_statement_balance: 0,
              copay_amount: 0,
              invoice: [],
              guarantor_due: []
            });
          }
        });
      } else if (
        !isConsolidatedBillingEnabled &&
        curPatientStatements.length === 0
      ) {
        // If consolidated billing is off, display only one card with the logged-in clinic as the location.
        patientItems.push({
          ...patient,
          clinic: {
            name: clinicDetails?.clinic_details?.name,
            id: clinicDetails?.clinic_id
          },
          total_statement_balance: 0,
          copay_amount: 0,
          invoice: [],
          guarantor_due: []
        });
      }
    });
    setPatientCardItems(patientItems);
    if (patientItems.length > 0) {
      if (isDesktop) {
        dispatch(_patientPaymentDetailsId(patientItems[0]));
      }
    } else {
      setGpPaymentDetailsFlag(false);
      props._patientPaymentDetailsId({});
    }
    return patientItems;
  };

  const init = () => {
    setLoader(true);
    verifyGuarantorToken()
      .then(res => {
        if (res.data) {
          let showChangeLocation = true;
          setApiResponseData(res.data);
          props._saveClinicDetails(res.data);

          if (res?.data?.guarantor_details?.previous_payment_plan_status) {
            setPaymentPlanStatus(true);
          } else {
            /**
             * CASE WHEN GUARANTOR EXIST IN DIFFERENT PRACTICES BUT, HAVE PAYMENT PLAN IN ONLY ONE PRACTICE
             */
            setPaymentPlanStatus(false);
          }
          // STORING GUARANTOR DETAILS.
          dispatch({
            type: BASE_DETAILS,
            payload: {data: {guarantorDetails: res?.data?.guarantor_details}}
          });
          dispatch({
            type: LOCATIONS,
            payload: {locations: res.data.locations}
          });

          setForceUpdate(forceUpdate + 1);
          if (!res?.data?.clinic_group_details?.consolidated_group_billing) {
            // Checking condition if there is only one practice that guarantor has dues on
            // switch to that clinic by default
            let clinicDataSelected: LocationsInterface | null = null;
            if (
              !apiResponseData?.clinic_id &&
              Array.isArray(res.data.locations)
            ) {
              const guarantorHasDues = res.data.locations.filter(l => {
                return l.guarantor_due?.current_due_amount > 0;
              });
              if (res.data.locations.length === 1) {
                showChangeLocation = false;
                clinicDataSelected = res.data.locations[0];
              } else {
                // if only one guarantor due exists then auto select
                if (guarantorHasDues.length === 1) {
                  showChangeLocation = false;
                  clinicDataSelected = guarantorHasDues[0];
                }
              }
              if (res.data.clinic_id) {
                // Check if clinic ID is present and current practice has zero balance, and other practice has balance then
                // 1. show dropdown if more than one practice has balance
                // 2. select the practice if only one practice has balance
                const selectedLocation = res.data.locations.find(
                  l => l.id === res.data.clinic_id
                );
                if (
                  (typeof selectedLocation?.guarantor_due
                    ?.current_due_amount === 'number' &&
                    selectedLocation?.guarantor_due.current_due_amount != 0) ||
                  guarantorHasDues.length === 0
                ) {
                  showChangeLocation = false;
                  clinicDataSelected = selectedLocation || null;
                }
              }
            }
            if (apiResponseData?.clinic_id) {
              showChangeLocation = false;
            }
            if (
              clinicDataSelected &&
              res.data.clinic_id !== clinicDataSelected.id
            ) {
              handleSelectPractice(clinicDataSelected);
            }
            // ** if the clinic details object doesn't exist in the res?.data then this below condition executes
            // This will call the refresh API to set the clinic details ** //
            else if (
              !res?.data?.clinic_details ||
              Object.keys(res.data.clinic_details).length === 0
            ) {
              setChangeLocation(true);
            }
          } else {
            showChangeLocation = false;
          }
          updatePatientsCardData({
            patientsList: res.data.patients ?? [],
            clinicDetails: res.data,
            patientsStatementsData: [],
            clinicsList: res.data.locations
          });
          // statements enable or not toggle check
          if (res?.data?.clinic_group_details?.statements || statementsEnable) {
            setLoader(true);
            fetchGuarantorPatients()
              .then(res1 => {
                if (typeof res1.data?.amount_paid === 'number') {
                  setPaidAmount(res1.data.amount_paid);
                } else {
                  setPaidAmount(0);
                }
                if (res1.data.current_due_amount > 0) {
                  setDisablePayButton(false);
                }
                const totalDueAmount = res1?.data?.current_due_amount ?? 0;
                props._guarantorPayAmount(totalDueAmount);
                props._guarantorPayCashAmount(totalDueAmount);
                setBalanceForward(res1.data.balance_forward);
                if (res1.data.balance_forward) {
                  props._saveBalanceForwardData({
                    amount: res1.data.balance_forward,
                    statementDate: '',
                    guarantorDetails: {
                      firstName: res.data.guarantor_details.first_name,
                      lastName: res.data.guarantor_details.last_name,
                      middleName: res.data.guarantor_details.middle_name
                    }
                  });
                } else {
                  dispatch(_saveBalanceForwardData(null));
                }
                // Fetch all patient details from different clinic statements from response
                let patientDetails: any = [],
                  currentDueAmount = 0,
                  copayAmount = 0,
                  chargeTypesAmount = 0,
                  copayIds: any = [],
                  chargeTypeIds: any = [],
                  chargeTypesList: any = [],
                  originalDueAmount = 0,
                  paidDueAmount = 0;
                if (
                  res1.data.clinic_statements &&
                  Array.isArray(res1.data.clinic_statements) &&
                  res1.data.clinic_statements.length > 0
                ) {
                  for (const statement of res1.data.clinic_statements) {
                    patientDetails = [
                      ...patientDetails,
                      ...statement.patient_details
                    ];
                    currentDueAmount += statement.current_due_amount;
                    copayAmount += statement.copay_amount;
                    chargeTypesAmount += statement.charge_types_amount;
                    copayIds = [...copayIds, ...statement.patient_copay_ids];
                    chargeTypeIds = [
                      ...chargeTypeIds,
                      ...statement.charge_type_ids
                    ];
                    chargeTypesList = [
                      ...chargeTypesList,
                      ...statement.charge_types_list
                    ];
                    /**
                     * Calculating original due amount and paid due amount
                     * 1. Statement balances
                     * 2. Copay balances
                     */
                    if (Array.isArray(statement.patient_details)) {
                      // commented:as same due amount repeats across all patients under this clinic 03/05/23
                      // statement.patient_details.forEach(details => {
                      //   if (Array.isArray(details?.guarantor_due)) {
                      //     details?.guarantor_due.forEach(due => {
                      //       originalDueAmount = originalDueAmount + due.original_due_amount || 0;
                      //       paidDueAmount = paidDueAmount + due.paid_due_amount || 0;
                      //     })
                      //   }
                      // });
                      if (
                        Array.isArray(statement.patient_details) &&
                        statement.patient_details?.length > 0 &&
                        Array.isArray(
                          statement.patient_details[0].guarantor_due
                        ) &&
                        statement.patient_details[0].guarantor_due?.length > 0
                      ) {
                        originalDueAmount =
                          originalDueAmount +
                            statement.patient_details[0].guarantor_due[0]
                              .original_due_amount || 0;
                        paidDueAmount =
                          paidDueAmount +
                            statement.patient_details[0].guarantor_due[0]
                              .paid_due_amount || 0;
                      }
                    }
                    if (Array.isArray(statement.charge_types_list)) {
                      statement.charge_types_list.forEach(miscCharge => {
                        originalDueAmount =
                          originalDueAmount + Number(miscCharge.charge_amount);
                        paidDueAmount =
                          paidDueAmount + Number(miscCharge.paid_amount);
                      });
                    }
                    setBalanceHighlight({
                      originalDueAmount: HelperUtils.fixTo2Decimals(
                        originalDueAmount
                      ),
                      paidDueAmount: HelperUtils.fixTo2Decimals(paidDueAmount)
                    });
                  }
                }
                props._saveAmountsAndRequiredDataForPayment({
                  dueAmount: currentDueAmount,
                  copayAmount: copayAmount,
                  patientCopayIds: copayIds,
                  chargeTypesAmount: chargeTypesAmount,
                  chargeTypesList: chargeTypesList,
                  chargeTypeIds: chargeTypeIds
                });
                updatePatientsCardData({
                  patientsList: res.data.patients ?? [],
                  clinicDetails: res.data,
                  patientsStatementsData: patientDetails,
                  clinicsList: res.data.locations
                });
              })
              .finally(() => {
                if (showChangeLocation) {
                  setLoader(false);
                  setChangeLocation(true);
                } else {
                  setLoader(false);
                  setChangeLocation(false);
                }
                // setTimeout(() => {
                //   setLoader(false);
                // }, 500);
              });
          }
          fetchPatientTicketAndAppointmentSummary()
            .then(patientTicketAndAppointmentSummaryRes => {
              dispatch(
                _setPatientTicketAndAppointmentSummary({
                  patientApptAndTicketSummary:
                    patientTicketAndAppointmentSummaryRes.data.patients
                })
              );
            })
            .catch(err => {
              if (err) {
                logoutAction();
              }
            });
        }
      })
      .catch(err => {
        if (err) {
          logoutAction();
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const patientPaymentDetails = useSelector(
    (state: any) => state.payments.patientPaymentDetailsId
  );

  const patientApptAndTicketSummary = useSelector(
    (state: State) => state.payments.patientApptAndTicketSummary
  );

  useEffect(() => {
    if (isLogin) {
      init();
    } else {
      props._guarantorLogin(false);
      history.push(`/${NavRoutes.PUBLIC.PAYMENTS_LOGIN}/pay/${token}`);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const renderCards = () => {
    return patientCardItems.map((item, index) => {
      const isPatientCardSelected =
        buttonAlert &&
        patientPaymentDetails?.id === item.id &&
        item?.clinic?.id === patientPaymentDetails?.clinic?.id;
      return (
        <div
          key={index}
          onClick={e => {
            navigateToPaymentDetails(item);
            e.stopPropagation();
          }}>
          <PaymentsCard
            onClick={(itemSectionId?: string) => {
              navigateToPaymentDetails(item, itemSectionId);
            }}
            token={match.params.token}
            border={
              isPatientCardSelected
                ? `2px solid ${APP_PRIMARY_COLOR}`
                : `1px solid ${BORDER_COLOR}`
            }
            accountName={item.emr_id}
            // date={invoiceDate}
            name={`${HelperUtils.commaSeparatedFullName(
              item.first_name,
              item.last_name,
              item.middle_name
            )}`}
            detailsId={item.id || 0}
            due={item?.total_statement_balance?.toString() || '0'}
            copayAmount={item?.copay_amount ?? '0'}
            key={item.id}
            clinic={item.clinic}
            patientId={item.id}
            showAppointentAndPriorAuthDetails
            isSelected={isPatientCardSelected}
            patientDetails={item}
          />
        </div>
      );
    });

    // COMMENTED THE CODE FOR REFERENCES
    // if (
    //   Array.isArray(patientsStatementsData) &&
    //   patientsStatementsData.length > 0
    // ) {
    //   patientsStatementsData.forEach((element, index) => {
    //     let amount = 0;
    //     // invoiceDate;
    //     if (Array.isArray(element.invoice) && element.invoice.length > 0) {
    //       element.invoice.forEach(invoice => {
    //         amount += parseFloat(invoice.due_amount || '0');
    //         // invoiceDate = invoice.invoice_date;
    //       });
    //     }
    //     nodes.push(
    //       <div
    //         // style={{border: '1px solid blue'}}
    //         // onClick={(): void => navigateToPaymentDetails(element)}
    //         key={index}>
    //         <PaymentsCard
    //           onClick={(itemSectionId?: string) =>
    //             navigateToPaymentDetails(element, itemSectionId)
    //           }
    //           border={
    //             (buttonAlert && idAlert === element.id) ||
    //             (isDesktop && !buttonAlert && index === 0 && !viewButtonAlert)
    //               ? `2px solid ${APP_PRIMARY_COLOR}`
    //               : `1px solid ${BORDER_COLOR}`
    //           }
    //           accountName={element.emr_id}
    //           // date={invoiceDate}
    //           name={`${HelperUtils.commaSeparatedFullName(
    //             element.first_name,
    //             element.last_name,
    //             element.middle_name
    //           )}`}
    //           detailsId={element.id || 0}
    //           due={amount.toString() || '0'}
    //           copayAmount={element?.copay_amount ?? '0'}
    //           key={element.id}
    //           clinic={element.clinic}
    //         />
    //       </div>
    //     );
    //   });
    //   return nodes;
    // } else {
    //   return <div />;
    // }
  };

  const redirectToSendEmail = (): void => {
    history.push(`/${NavRoutes.PUBLIC.SEND_EMAIL}/${token}`);
  };
  //  Here.... load the Guarantor practice selection....

  if (
    ((showDueNoticeFirstTime && payAmount > 0) || showAlertDialog) &&
    (apiResponseData?.guarantor_details?.due_notice_type ===
      StatementNoticeType.PD.key ||
      apiResponseData?.guarantor_details?.due_notice_type ===
        StatementNoticeType.FN.key)
  ) {
    return (
      <GuarantorNotice
        fullScreen={!isDesktop}
        description={apiResponseData.guarantor_details.notice_template || ''}
        title={
          apiResponseData?.guarantor_details?.due_notice_type ===
          StatementNoticeType.FN.key
            ? t('PAYMENTS_LOGIN.NOTICE.FN_NOTICE')
            : apiResponseData?.guarantor_details?.due_notice_type ===
              StatementNoticeType.PD.key
            ? t('PAYMENTS_LOGIN.NOTICE.PD_NOTICE')
            : ''
        }
        clinicDetails={{
          name: apiResponseData?.clinic_details?.name,
          address: `${apiResponseData?.clinic_details?.address || ''} ${
            apiResponseData?.clinic_details.address_line_2 || ''
          }`,
          city: apiResponseData?.clinic_details.city,
          state: apiResponseData?.clinic_details.state,
          zip: apiResponseData?.clinic_details.zip
            ? apiResponseData.clinic_details.zip.toString()
            : '',
          phone: apiResponseData?.clinic_details.phone
            ? apiResponseData.clinic_details.phone.toString()
            : ''
        }}
        onClose={() => {
          setAlertDialog(false);
          props._updateShowDueNoticeFirstTime(false);
        }}
      />
    );
  }

  // if (changeLocation) {
  //   return (

  //   );
  // }

  const patientWithFormStatus = patientApptAndTicketSummary.find(sItem => {
    const hasCardPatient = patientCardItems.some(pItem => {
      return pItem?.id === sItem?.id && pItem?.clinic?.id === sItem?.clinic_id;
    });
    return hasCardPatient && sItem?.patient_form_status === 'sent';
  });

  const getClinicName = (patientFormClinicId: number) => {
    // IF PATIENT SHARED IS ON AND CONSOLIDATED BILLING IS ON FIND THE CLINIC NAME FROM THE CLINIC LIST
    if (
      apiResponseData?.clinic_group_details?.patients_shared &&
      apiResponseData?.clinic_group_details?.consolidated_group_billing
    ) {
      if (Array.isArray(apiResponseData?.locations)) {
        const reqClinic = apiResponseData.locations.find(
          i => i.id === patientFormClinicId
        );
        if (reqClinic) {
          return reqClinic.name;
        }
      }
    } else {
      return apiResponseData?.clinic_details?.name;
    }
  };

  const renderPatientOutstandingBalance = () => {
    if (loader) {
      return <Loader />;
    }
    return (
      <>
        {/* payments Text View Start */}
        {(apiResponseData?.guarantor_details?.due_notice_type ===
          StatementNoticeType.PD.key ||
          apiResponseData?.guarantor_details?.due_notice_type ===
            StatementNoticeType.FN.key) && (
          <div className={classes.noticeTypeWrapper}>
            <span className="input-header">
              {apiResponseData?.guarantor_details?.due_notice_type ===
              StatementNoticeType.FN.key
                ? t('PAYMENTS_LOGIN.NOTICE.FN_NOTICE')
                : apiResponseData?.guarantor_details?.due_notice_type ===
                  StatementNoticeType.PD.key
                ? t('PAYMENTS_LOGIN.NOTICE.PD_NOTICE')
                : ''}
            </span>
            <Button
              className={classes.viewNoticeButton}
              variant={'outlined'}
              onClick={() => {
                setAlertDialog(true);
              }}>
              {t('PAYMENTS_LOGIN.NOTICE.VIEW')}
            </Button>
          </div>
        )}
        {statementsEnable && (
          <>
            <div
              style={{
                display: 'flex',
                alignContent: 'center',
                alignItems: 'center',
                fontSize: '1rem',
                justifyContent: 'space-between'
              }}
              className="payments-text">
              <span className="input-header">
                <div className={classes.displayFlex}>
                  <p>{t('PAYMENTS_LOGIN.DASHBOARD.ORIGINAL_BALANCE')} </p>
                </div>
              </span>
              <CurrencyFormatter
                value={balanceHighlight.originalDueAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
                ignoreRound={true}
                useSign={true}
              />
            </div>
            <div
              style={{
                display: 'flex',
                alignContent: 'center',
                alignItems: 'center',
                fontSize: '1rem',
                justifyContent: 'space-between'
              }}
              className="payments-text">
              <span className="input-header">
                <div className={classes.displayFlex}>
                  <p>{t('PAYMENTS_LOGIN.DASHBOARD.PAID')} </p>
                </div>
              </span>
              <CurrencyFormatter
                value={balanceHighlight.paidDueAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
                ignoreRound={true}
                useSign={true}
              />
            </div>
            {
              // ** Payments enable then the below section shows up in the UI **//
              paymentsEnable && (
                <div
                  style={{
                    display: 'flex',
                    alignContent: 'center',
                    alignItems: 'center',
                    justifyContent:
                      payAmount > 0 ? 'space-between' : 'flex-start'
                  }}
                  className="payments-text">
                  {/* <Typography
          component={'div'}>
          {t('PAYMENTS_LOGIN.DASHBOARD.PATIENTS_VISIT')}
          </Typography> */}
                  <span className="input-header">
                    {payAmount > 0 ? (
                      <div className={classes.displayFlex}>
                        <p>{t('PAYMENTS_LOGIN.DASHBOARD.PATIENTS_VISIT')} </p>
                      </div>
                    ) : (
                      t('PAYMENTS_LOGIN.DASHBOARD.PATIENTS_VISIT_NULL')
                    )}
                  </span>
                  {payAmount > 0 ? (
                    <CurrencyFormatter
                      value={payAmount}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'$'}
                      ignoreRound={true}
                      useSign={true}
                    />
                  ) : (
                    <Tooltip
                      title={`${t(
                        'PAYMENTS_LOGIN.DASHBOARD.NO_PATIENTS_BALANCE'
                      )}`}
                      placement="top">
                      <CheckCircleIcon
                        style={{color: APP.STATUS.SUCCESS}}
                        fontSize={'small'}
                      />
                    </Tooltip>
                  )}
                </div>
              )
            }
          </>
        )}
        {/* payment text view end */}

        {balanceForward ? (
          <div
            style={{
              display: 'flex',
              marginTop: '1rem',
              flexDirection: 'row'
            }}>
            <Typography>
              {t('PAYMENTS_LOGIN.DASHBOARD.BALANCE_FORWARD')}
            </Typography>
            <span style={{marginLeft: '1rem'}}>
              <CurrencyFormatter
                value={balanceForward}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'$'}
                ignoreRound={true}
                useSign={true}
              />
            </span>
          </div>
        ) : (
          ''
        )}
        {/* cards view start */}
        {renderCards()}
        {/* cards view end */}

        {/* divider View start */}
        <div className="dividerView" />
        {/* divider view end */}
      </>
    );
  };

  const getSupportEmail = (): string => {
    if (
      apiResponseData?.clinic_group_details?.patients_shared === true &&
      apiResponseData?.clinic_group_details?.contact_email
    ) {
      return apiResponseData.clinic_group_details.contact_email;
    }
    if (
      apiResponseData?.clinic_group_details?.patients_shared === false &&
      apiResponseData?.clinic_details?.contact_email
    ) {
      return apiResponseData.clinic_details.contact_email;
    }
    return environment.supportEmail;
  };

  const renderPortalHosTitle = (): string | undefined => {
    if (apiResponseData?.clinic_id) {
      return apiResponseData.clinic_details?.name;
    }
    return apiResponseData?.clinic_group_details?.group_name;
  };

  const renderAfterContent = (): ReactElement => (
    <div className="payment-login-after-content">
      <section className="flex-centering contact-section">
        <p className="contact-us-text">
          <Trans
            i18nKey="GUARANTOR_PORTAL.LOGIN_SCREEN.CONTACT_INFO2"
            values={{supportEmail: getSupportEmail()}}
            components={[
              <Link href={`mailto:${getSupportEmail()}`} key="support-email" />
            ]}
          />
        </p>
      </section>

      <div className="tag-wrapper flex-centering">
        <p className="tag-text">
          <Trans
            i18nKey="GUARANTOR_PORTAL.LOGIN_SCREEN.APP_CLOSING_INFORMATION_PART3"
            components={[<span key="closing-information" />]}
          />
        </p>
        <p className="tag-text-2">
          {t('GUARANTOR_PORTAL.LOGIN_SCREEN.APP_CLOSING_INFORMATION_PART2')}
        </p>
        <Link href={`${environment.websiteDetails.name}`} target="pcl">
          <MedopsLogo className="logo" />
        </Link>
      </div>
    </div>
  );

  const renderDashboardContent = (): ReactElement => (
    <div className="payments-dashboard-wrapper">
      <div style={{flex: 1, display: 'flex'}}>
        <Card
          className={['payments-dashboard-content-wrap', classes.card].join(
            ' '
          )}>
          <CardContent className={[classes.cardPadding, 'content'].join(' ')}>
            <div className="dashboard-content-view">
              <div style={{flexDirection: 'row', display: 'flex'}}>
                {!isLogin && (
                  <div>
                    <Typography className="details-view" component={'div'}>
                      <BackNavigation navigateTo={backNavigation} />
                    </Typography>
                  </div>
                )}
                <div
                  style={{
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    display: 'flex',
                    flex: 1
                  }}>
                  <Typography className="details-view" component={'div'}>
                    <Button
                      onClick={logoutAction}
                      size={'large'}
                      variant={'outlined'}
                      color="primary"
                      style={{
                        textTransform: 'capitalize'
                      }}>
                      Logout
                    </Button>
                  </Typography>
                </div>
              </div>

              {/* clinic name and address view start */}
              <div className={classes.scrollSection}>
                <Typography
                  className="clinic-address input-header"
                  variant={'h3'}
                  component={'div'}>
                  <div className="titleView">
                    <div
                      className={['clinic-name', classes.displayFlex].join(
                        ' '
                      )}>
                      <p>{apiResponseData?.clinic_details?.name}</p>
                      {locations &&
                        locations?.length > 0 &&
                        !apiResponseData?.clinic_group_details
                          .consolidated_group_billing && (
                          <p
                            className={[classes.link, classes.linkPadding].join(
                              ' '
                            )}
                            onClick={() => {
                              setChangeLocation(true);
                            }}>
                            {t('PAYMENTS_LOGIN.CHANGE_LOCATION.TITLE')}
                          </p>
                        )}
                    </div>
                    <div className="address-text">
                      {HelperUtils.formatFullAddress({
                        line1: apiResponseData?.clinic_details?.address,
                        line2:
                          apiResponseData?.clinic_details?.address_line_2 || ''
                      })}
                    </div>
                    <div className="address-text">
                      {HelperUtils.formatFullAddress({
                        city: apiResponseData?.clinic_details?.city,
                        state: apiResponseData?.clinic_details?.state + ',',
                        country: '',
                        zip: (
                          apiResponseData?.clinic_details?.zip || ''
                        ).toString()
                      })}
                    </div>
                    <div className="address-text">
                      {apiResponseData?.clinic_details?.phone ===
                      apiResponseData?.clinic_details?.billing_phone ? (
                        apiResponseData?.clinic_details?.phone && (
                          <>
                            {t('PAYMENTS_LOGIN.PRACTICE_PHONE_LABEL')}
                            <PhoneFormatter
                              value={
                                apiResponseData?.clinic_details.phone.startsWith(
                                  '+1'
                                )
                                  ? apiResponseData?.clinic_details?.phone
                                  : '+1' +
                                    apiResponseData?.clinic_details?.phone
                              }
                            />
                          </>
                        )
                      ) : (
                        <>
                          <p>
                            {apiResponseData?.clinic_details?.phone && (
                              <>
                                {t('PAYMENTS_LOGIN.PRACTICE_PHONE_LABEL')}
                                <PhoneFormatter
                                  value={
                                    apiResponseData?.clinic_details.phone.startsWith(
                                      '+1'
                                    )
                                      ? apiResponseData?.clinic_details?.phone
                                      : '+1' +
                                        apiResponseData?.clinic_details?.phone
                                  }
                                />
                              </>
                            )}
                          </p>
                          <p>
                            {apiResponseData?.clinic_details?.billing_phone && (
                              <>
                                {t('PAYMENTS_LOGIN.BILLING_PHONE_LABEL')}
                                <PhoneFormatter
                                  value={
                                    apiResponseData?.clinic_details.billing_phone.startsWith(
                                      '+1'
                                    )
                                      ? apiResponseData?.clinic_details
                                          ?.billing_phone
                                      : '+1' +
                                        apiResponseData?.clinic_details
                                          ?.billing_phone
                                  }
                                />
                              </>
                            )}
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="logoView">
                    {apiResponseData?.clinic_details?.clinic_logo_url ? (
                      <img
                        alt={'clinic-logo'}
                        src={apiResponseData?.clinic_details?.clinic_logo_url}
                      />
                    ) : (
                      <ClinicGroupsIcon
                        style={{height: '64px', width: '64px'}}
                      />
                    )}
                  </div>
                </Typography>
                {/* clinic name and address view end */}

                {/* Guarantor name view start */}
                <Typography
                  className="patient-name input-header"
                  component={'div'}>
                  {t('PAYMENTS_LOGIN.DASHBOARD.HELLO', {
                    // name: apiResponseData?.guarantor_details?.name,
                    name: HelperUtils.formFullName(
                      apiResponseData?.guarantor_details?.first_name,
                      apiResponseData?.guarantor_details?.last_name,
                      apiResponseData?.guarantor_details?.middle_name
                    )
                  })}
                  ,
                </Typography>
                {apiResponseData?.clinic_group_details?.patient_forms &&
                  patientWithFormStatus && (
                    <p
                      style={{
                        marginTop: '1rem',
                        marginBottom: '0.5rem',
                        textAlign: 'left'
                      }}>
                      {t('PATIENT_MEDICARE_FORM.FILL_CLINIC_FORM_TEXT', {
                        clinicName:
                          getClinicName(patientWithFormStatus?.clinic_id) || '',
                        formName: 'Medicare Beneficiary Form'
                      })}
                    </p>
                  )}
                {/* </Typography> */}
                {/* Guarantor name view end */}

                {/* payments info text view start */}
                <Typography
                  className="cards-info-text input-header"
                  component={'div'}>
                  {payAmount > 0 && t('PAYMENTS_LOGIN.DASHBOARD.CARD_INFO')}
                  <br />
                  <br />
                  {/* {apiResponseData?.clinic_group_details
                    ?.vaccine_appointments_enable ? (
                    <>
                      <Trans
                        i18nKey={
                          'APPOINTMENTS_SCHEDULAR_PORTAL.HOME_SCREEN.VIEW_VACCINE_SUBTITLE'
                        }
                        components={[
                          <Link
                            key={'X'}
                            variant="body2"
                            // className={classes.ClickHere}
                            type={'button'}
                            component="button"
                            // disabled={isLoadingAppointmentList}
                            onClick={() => {
                              history.push(
                                `/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}/${token}/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.HOME}`
                              );
                              dispatch(_appointmentPortalLogin(true));
                              dispatch(_guarantorLogin(false));
                            }}
                            className={classes.clickHereLink}
                          />
                        ]}
                      />
                      <br />
                      <br />
                    </>
                  ) : (
                    ''
                  )} */}
                  {apiResponseData?.clinic_details?.clinic_contact_text ||
                    t('ADD_CLINIC.DEFAULT_VALUE.CLINIC_CONTACT_TEXT')}
                  <br />
                  <br />

                  {paymentsEnable &&
                    locations &&
                    locations?.length > 0 &&
                    !apiResponseData?.clinic_group_details
                      ?.consolidated_group_billing && (
                      <p>
                        <Trans
                          i18nKey={
                            'PAYMENTS_LOGIN.CHANGE_LOCATION.CLINIC_BALANCE_SECTION'
                          }
                          values={{
                            practice_name:
                              apiResponseData?.clinic_details?.name,
                            click: 'click'
                          }}
                          components={[
                            <strong
                              key={'X'}
                              onClick={() => {
                                setChangeLocation(true);
                              }}
                              style={{
                                cursor: 'pointer',
                                color: APP_PRIMARY_COLOR,
                                textDecoration: 'underline'
                              }}
                            />,
                            <strong
                              key={'Y'}
                              style={{
                                fontWeight: 600
                              }}
                            />
                          ]}
                        />
                      </p>
                    )}
                </Typography>
                {/* payments info text view end*/}

                {renderPatientOutstandingBalance()}
                {/* pay on desktop view start */}
                {isMobile && !disablePayButton && (
                  <Typography
                    className="desktop-mail-main-view input-header"
                    component={'div'}>
                    <div className="info-view">
                      <div className="pay-text-main-view">
                        {t('PAYMENTS_LOGIN.DASHBOARD.DESKTOP')}
                      </div>
                      <div className="text">
                        {t('PAYMENTS_LOGIN.DASHBOARD.DESKTOP_INFO')}
                      </div>
                    </div>
                    <div
                      className="send-link-button-view"
                      style={{flex: 0.5, paddingLeft: '1.5rem'}}>
                      <Button
                        fullWidth
                        variant="contained"
                        size={'medium'}
                        className={[classes.loginButton, 'button'].join(' ')}
                        onClick={(): void => redirectToSendEmail()}>
                        {t('PAYMENTS_LOGIN.DASHBOARD.SEND_LINK')}
                      </Button>
                    </div>
                  </Typography>
                )}
              </div>
              {/* pay on desktop view end */}
            </div>
            {paymentsEnable && (
              <div
                className={`buttonView ${!isDesktop ? 'button-view-mob' : ''}`}>
                {paidAmount > 0 || paymentPlanStatus ? (
                  <div
                    className={`button-sub-text-paid-amount`}
                    style={{
                      border: viewButtonAlert
                        ? `2px solid ${APP_PRIMARY_COLOR}`
                        : `1px solid ${BORDER_COLOR}`
                    }}
                    onClick={viewAllPaymentsOfGp}>
                    <div
                      style={{
                        // marginLeft: '4px',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        display: 'flex'
                      }}>
                      <Button
                        size={'small'}
                        color="primary"
                        style={{
                          textTransform: 'capitalize'
                        }}>
                        {paymentPlanStatus
                          ? t('PAYMENT_PLANS.VIEW_PAYMENTS_PLAN')
                          : t('PAYMENT_PLANS.VIEW_PAYMENTS')}
                      </Button>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {payAmount > 0 ? (
                  <Button
                    fullWidth
                    variant="contained"
                    size={'medium'}
                    color="primary"
                    className={[classes.loginButton].join(' ')}
                    type={'submit'}
                    style={{height: '3.5rem'}}
                    disabled={disablePayButton}
                    onClick={navigateToPaymentSection}>
                    {t('PAYMENTS_LOGIN.DASHBOARD.PAY_LABEL')}
                  </Button>
                ) : null}
              </div>
            )}
          </CardContent>
        </Card>
      </div>

      {changeLocation && (
        <PracticeSelection
          guarantor={{
            firstName: apiResponseData?.guarantor_details.first_name || '',
            middleName: apiResponseData?.guarantor_details.middle_name || '',
            lastName: apiResponseData?.guarantor_details.last_name || ''
          }}
          open={changeLocation}
          title={t('PAYMENTS_LOGIN.CHANGE_LOCATION.DIALOG_TITLE')}
          fullScreen={!isDesktop}
          groupDetails={{
            name: apiResponseData?.clinic_group_details.group_name || '',
            address: apiResponseData?.clinic_group_details.address || '',
            address2:
              apiResponseData?.clinic_group_details.address_line_2 || '',
            zip: apiResponseData?.clinic_group_details.zip || '',
            city: apiResponseData?.clinic_group_details.city || '',
            state: apiResponseData?.clinic_group_details.state || ''
          }}
          practiceList={locations.map(l => {
            return {
              id: l.id,
              address: l.address || '',
              address2: l.address_line_2 || '',
              city: l.city,
              state: l.state,
              zip: l.zip || '',
              name: l.name,
              clinicLogoUrl: l.clinic_logo_url || null,
              balance: l.guarantor_due?.current_due_amount || 0
            };
          })}
          onClose={() => {
            setChangeLocation(false);
          }}
          // TO DO HANDLE PRACTICE SELECTION.
          onClick={clinic => {
            dispatch(_patientPaymentDetailsId({}));
            handleSelectPractice(clinic);
            setChangeLocation(false);
            setViewButtonAlert(false);
            setGpPaymentDetailsFlag(false);
          }}
          selectedPractice={{
            zip: apiResponseData?.clinic_details?.zip || '',
            address: apiResponseData?.clinic_details?.address || '',
            address2: apiResponseData?.clinic_details?.address_line_2 || '',
            city: apiResponseData?.clinic_details?.city || '',
            id: apiResponseData?.clinic_details?.id || 0,
            name: apiResponseData?.clinic_details?.name || '',
            state: apiResponseData?.clinic_details?.state || '',
            clinicLogoUrl: null,
            balance: 0
          }}
        />
      )}
      {gpPaymentDetailsFlag && isDesktop && paymentsEnable && (
        <div style={{flex: 1, display: 'flex'}}>
          <GuarantorPaymentDetails
            forceUpdate={forceUpdate}
            isConsolidatedBilling={
              apiResponseData?.clinic_group_details?.consolidated_group_billing
            }
            isConvenienceFeeExist={
              apiResponseData &&
              // @ts-ignore
              apiResponseData?.clinic_details?.convenience_fee > 0
                ? apiResponseData?.clinic_details?.convenience_fee
                : 0
            }
          />
        </div>
      )}
      {isDesktop && !gpPaymentDetailsFlag && (
        <div style={{flex: 1, display: 'flex'}}>
          {/* @ts-ignore */}
          <PaymentsDetails defaultSectionId={sectionId} />
        </div>
      )}
    </div>
  );

  return (
    <PublicPageLayout
      className="payment-dashboard-page payment-login-page"
      testId="pcl-guarantor-paymentDashboard"
      showHero={false}
      contentLayout="plain"
      practiceBadgeLabel={renderPortalHosTitle()}
      showPracticeInfo={false}
      afterContent={apiResponseData ? renderAfterContent() : undefined}>
      {renderDashboardContent()}
    </PublicPageLayout>
  );
};

function mapStateToProps(state: any): any {
  return {
    patientPaymentsToken: state.payments.patientPaymentsToken,
    isLogin: state.payments.isLogin,
    patientPaymentDetailsId: state.payments.patientPaymentDetailsId
  };
}
export default connect(mapStateToProps, {
  _guarantorPayAmount,
  _guarantorPayCashAmount,
  _updateShowDueNoticeFirstTime,
  _saveClinicDetails,
  _patientPaymentDetailsId,
  _setPatientPaymentsToken,
  _guarantorLogin,
  _saveAmountsAndRequiredDataForPayment,
  _saveBalanceForwardData
})(PaymentsDashBoard);
